import { render } from "./CreateTicket.vue?vue&type=template&id=676a71ad"
import script from "./CreateTicket.vue?vue&type=script&lang=js"
export * from "./CreateTicket.vue?vue&type=script&lang=js"

import "./CreateTicket.vue?vue&type=style&index=0&id=676a71ad&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__